import tw, { styled } from "twin.macro";

const Hidden = styled.div`
    && {
        ${tw`hidden`}
    }
`;

export default Hidden;